import ChartEmptyState from './ChartEmptyState.component';

export default ChartEmptyState;
